<template>
    <div class="fill-height d-flex align-center justify-space-around login-bg">
        <div class="d-flex flex-column align-center" style="width: 350px">
            <div class="pb-3">
                <img alt="logo" src="images/logo_full_dark-01.svg" width="500px"/>
            </div>
            <div class="pa-2" style="width: 100%">

                <div v-if="loginStage === 0">
                    <div class="pb-2">
                        <v-text-field
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                placeholder="Username"
                                hide-details="auto"
                                :disabled="loggingIn"
                                v-model="username"
                                @keydown.enter="password && password.length ? (username && username.length ? login() : $refs.password.focus()) : $refs.password.focus()"
                                ref="username"
                                color="primary"
                                dark
                        />
                    </div>
                    <div class="pb-2">
                        <v-text-field
                                color="primary"
                                dark
                                outlined
                                dense
                                prepend-inner-icon="mdi-key-variant"
                                placeholder="Password"
                                hide-details="auto"
                                :disabled="loggingIn"
                                v-model="password"
                                type="password"
                                ref="password"
                                @keydown.enter="username && username.length ? (password && password.length ? login() : $refs.username.focus()) : $refs.username.focus()"
                        />
                    </div>
                    <div class="d-flex align-center justify-space-between">
<!--                        <div class="amber&#45;&#45;text caption text-start hover-underline-text" style="line-height: 1; cursor: pointer" @click="$store.state.signup = true">-->
<!--                            Sign Up?-->
<!--                        </div>-->
                        <div class="amber--text caption text-end hover-underline-text" style="line-height: 1; cursor: pointer" @click="showResetDlg = true">
                            Forgot Password?
                        </div>
                    </div>

                </div>
                <!--                </v-scroll-x-transition>-->
                <v-scroll-x-reverse-transition>
                    <div class="pb-2" v-if="loginStage === 1">
                        <v-text-field
                                color="primary"
                                dark
                                compact
                                dense
                                outlined
                                prepend-inner-icon="mdi-lock-clock"
                                placeholder="TOTP"
                                hide-details="auto"
                                :disabled="checkingOTP"
                                v-model="otp"
                                ref="totpField"
                                @keydown.enter.prevent="authOTP"
                        />
                    </div>
                </v-scroll-x-reverse-transition>
                <div class="amber--text caption text-end hover-underline-text" v-if="loginStage === 1" style="line-height: 1; cursor: pointer" @click="showDisableTotpDlg = true">
                    Reset TOTP?
                </div>
            </div>
            <div class="d-flex flex-column align-center justify-center">
                <div>
                    <v-btn
                            elevation="2"
                            color="primary"
                            small
                            :loading="loggingIn"
                            :disabled="loggingIn"
                            @click="username && username.length && password && password.length ? (loginStage === 0 ? login() : authOTP()) : $snack.error('Username and password required.')"
                            outlined
                    >
                        {{ loginStage === 0 ? 'Next' : 'Login' }}
                    </v-btn>
                </div>

                <div class="overline pt-3 amber--text text-center" v-if="!!loginError">
                    {{ loginError }}
                </div>
            </div>
        </div>

        <v-dialog
                v-model="showSiteSelect"
                :persistent="true"
                width="400"
        >
            <v-card max-width="400">
                <v-card-title class="text-h5">
                    Select Site
                </v-card-title>

                <v-card-text class="px-0 pb-0">
                    <v-list dense>
                        <v-list-item
                                @click="siteSelected(site)"
                                v-for="site in sites"
                                :disabled="site.disabled"
                                :key="site._id"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-domain</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                {{site.name}}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-dialog
                v-model="showResetDlg"
                :persistent="true"
                width="400"
                :overlay-opacity="0.8"
                overlay-color="black"
        >
            <v-card max-width="400">
                <v-card-title class="dlg-title-bar">
                    Reset Password
                </v-card-title>

                <v-card-text v-if="resetSent">
                    <div class="d-flex justify-center">
                        <v-icon color="primary" :dense="true" :size="80">mdi-email-fast-outline</v-icon>
                    </div>
                    <div class="text-subtitle-1 primary--text text-center">
                        Reset Link Sent
                        <br>
                        Remember to check your spam folder
                    </div>
                </v-card-text>

                <v-card-text v-else>
                    <v-form ref="resetPassword" @submit="$event.preventDefault()">
                        <v-text-field
                                ref="resetPasswordEmailField"
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                placeholder="eg. person@domain.com"
                                label="Email Address"
                                :disabled="loggingIn"
                                v-model="resetEmailAddress"
                                color="primary"
                                dark
                                :rules="[validationRules.required, validationRules.email]"
                                hide-details="auto"
                                class="pt-4"
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end" v-if="!resetSent">
                    <v-btn
                            small
                            outlined
                            @click="showResetDlg = false"
                            class="mr-2"
                            color="primary"
                            :disabled="resettingEmailAddress"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            small
                            @click="sendResetEmail"
                            color="primary"
                            :disabled="resettingEmailAddress"
                            :loading="resettingEmailAddress"
                    >
                        Reset Password
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog
                v-model="showDisableTotpDlg"
                :persistent="true"
                width="400"
                :overlay-opacity="0.8"
                overlay-color="black"
        >
            <v-card max-width="400">
                <v-card-title class="dlg-title-bar">
                    Reset TOTP
                </v-card-title>

                <v-card-text>
                    <v-form ref="recoveryKeyForm" @submit="$event.preventDefault()">
                        <v-text-field
                                ref="recoveryKeyField"
                                outlined
                                dense
                                prepend-inner-icon="mdi-account"
                                placeholder="XXXX-XXXXXX-XXXXX-XXX..."
                                label="Recovery Key"
                                v-model="recoveryKey"
                                color="primary"
                                dark
                                :rules="[validationRules.required]"
                                hide-details="auto"
                                class="pt-4"
                                :disabled="disablingTotp"
                                @input="recoveryKeyError = null"
                                :error-messages="recoveryKeyError ? [recoveryKeyError] : null"
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end" v-if="!resetSent">
                    <v-btn
                            small
                            outlined
                            @click="showDisableTotpDlg = false"
                            class="mr-2"
                            color="primary"
                            :disabled="disablingTotp"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            small
                            @click="disableTotp"
                            color="primary"
                            :disabled="disablingTotp"
                            :loading="disablingTotp"
                    >
                        Reset TOTP
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-totp-setup
                v-if="showTotpSetup"
                v-model="showTotpSetup"
                @verified="nextStep"
                :uri="totpUri"
                :recovery-key="totpRecoveryKey"
                :username="username"
        />
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import AppTotpSetup from "@/components/Login/AppTotpSetup";
import {initializeRequestAuth, initializeSite} from '@/core/request'
import {validationRules} from "@/core/codeFunctions";

export default {
    components: {AppTotpSetup},
    props: {},
    data() {
        return {
            loggingIn: false,
            username: null,
            password: null,
            loginError: null,
            showTotpSetup: false,
            totpUri: null,
            totpRecoveryKey: null,
            loginStage: 0,
            checkingOTP: false,
            otp: null,
            showSiteSelect: false,
            sites: [],
            showResetDlg: false,
            resetEmailAddress: null,
            validationRules: validationRules,
            resetSent: false,
            resettingEmailAddress: false,
            disablingTotp: false,
            recoveryKey: null,
            showDisableTotpDlg: false,
            recoveryKeyError: null
        }
    },
    watch: {
        showResetDlg(val) {
            if (val)
                setTimeout(() => {
                    if (this.$refs.resetPasswordEmailField)
                        this.$refs.resetPasswordEmailField.focus()
                }, 500)
        }
    },
    mounted() {

        this.$vuetify.theme.dark = true
    },
    methods: {
        ...mapActions(["setLogin"]),

        async disableTotp() {
            try {
                if (!this.$refs.recoveryKeyForm.validate())
                    return

                this.disablingTotp = true
                const {status} = await this.$newReq("POST", `login/disableTotp`, {
                    username: this.username,
                    password: this.password,
                    recoveryKey: this.recoveryKey
                }, false)


                if (status === 'failed')
                    return this.recoveryKeyError = 'Invalid Recovery Key';

                this.showDisableTotpDlg = false;

                this.login();
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.disablingTotp = false
            }
        },

        async sendResetEmail() {
            try {

                this.resettingEmailAddress = true

                await this.$newReq("POST", `login/resetPassword`, {username: this.resetEmailAddress}, false)

                this.resetSent = true;
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.resettingEmailAddress = false
            }
        },

        async selectSite() {
            const siteConfig = await this.$newReq("GET", `userSites`);
            this.sites = siteConfig.sites;

            if (siteConfig.default) {
                this.$store.state.curSiteId = siteConfig.default;
                initializeSite(siteConfig.default)
                this.setLogin(true);
                return;
            }

            if (siteConfig.sites.length === 1) {
                this.$store.state.curSiteId = siteConfig.sites[0]._id;
                initializeSite(siteConfig.sites[0]._id)
                this.setLogin(true);
                return;
            }

            this.showSiteSelect = true;
        },


        siteSelected(site) {
            this.$store.state.curSiteId = site._id;
            initializeSite(site._id)
            this.showSiteSelect = false;
            this.setLogin(true);
        },

        nextStep(code) {
            this.showTotpSetup = false;
            this.loginStage = 1;
            this.otp = code;
            this.authOTP();
        },

        async login() {
            if (!this.username || !this.password)
                return this.$snack.error('Username & Password are required')

            this.loggingIn = true
            this.loginError = null
            try {
                const res = await this.$newReq("POST", `login`, {
                    username: this.username,
                    password: this.password
                }, false)
                if (res.twoFactorSetup) {
                    this.showTotpSetup = true;
                    this.totpUri = res.twoFactorSetup.uri;
                    this.totpRecoveryKey = res.twoFactorSetup.recoveryKey;
                    return;
                }

                if (res.totpLogin) {
                    this.loginStage = 1
                    setTimeout(() => {
                        if (this.$refs.totpField)
                            this.$refs.totpField.focus()
                    }, 500)
                    return;
                }

                if (res.token) {
                    initializeRequestAuth(res.token);
                    this.$store.state.userId = res.token.userId;
                    this.selectSite();
                } else {
                    throw new Error('Invalid Login')
                }

            } catch (e) {
                if (typeof e === 'string')
                    return this.loginError = e

                if (e.response && e.response.status === 401) {
                    this.loginError = e.response.data
                } else {
                    this.loginError = "Server Error"
                }
            } finally {
                this.loggingIn = false
            }
        },

        async authOTP() {
            if (!this.otp || this.otp.length !== 6)
                return this.$snack.error('Invalid OTP Code')

            this.loggingIn = true
            this.loginError = null
            try {

                const res = await this.$newReq("POST", `login/auth`, {
                    username: this.username,
                    password: this.password,
                    otp: this.otp
                }, false);

                if (res.token) {
                    initializeRequestAuth(res.token);
                    this.$store.state.userId = res.token.userId;
                    this.selectSite();
                } else {
                    throw new Error('Invalid Login')
                }
            } catch (e) {
                if (typeof e === 'string')
                    return this.loginError = e
                if (e.response && e.response.status === 401) {
                    this.loginError = e.response.data
                } else {
                    this.loginError = "Server Error"
                }
            } finally {
                this.loggingIn = false
            }
        }
    },
    computed: {
        ...mapGetters(['live'])
    },
}
</script>

<style scoped>

.login-bg {
    height: 100%;
    width: 100vw;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(0, 0, 0, 1) 0%, rgba(32, 32, 32, 1) 70%, rgba(45, 45, 45, 1) 70.1%, rgba(19, 19, 19, 1) 100%);
    font-weight: 200;
}

</style>